import { render, staticRenderFns } from "./AdminBookLists.vue?vue&type=template&id=8d9912d2&scoped=true&"
import script from "./AdminBookLists.vue?vue&type=script&lang=js&"
export * from "./AdminBookLists.vue?vue&type=script&lang=js&"
import style0 from "./AdminBookLists.vue?vue&type=style&index=0&id=8d9912d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-2f6a8101d6/2/home/apps/.yarn/berry/cache/vue-loader-npm-15.10.1-3a0b6c19d2-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9912d2",
  null
  
)

export default component.exports